export default "__VITE_ASSET__B0Soo1Ic__"